import React from 'react';
/**
 * A Component which forbid interactive with children
 */
export var RenderInteractiveMask = React.memo(function (props) {
    return React.createElement("div", { className: "render-interactive-mask" }, props.children);
});
RenderInteractiveMask.displayName = 'RenderInteractiveMask';
